import ChipExample from "../../../../src/pages/components/chips/example.js";
import ChipOutline from "../../../../src/pages/components/chips/chipOutline.js";
import ChipSize from "../../../../src/pages/components/chips/chipSize.js";
import * as React from 'react';
export default {
  ChipExample,
  ChipOutline,
  ChipSize,
  React
};